function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e2) { throw _e2; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e3) { didErr = true; err = _e3; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

import { extend } from "../shared/utils/extend.js";
import { canUseDOM } from "../shared/utils/canUseDOM.js";
import { Base } from "../shared/Base/Base.js";
import { Carousel } from "../Carousel/Carousel.js";
import { Plugins } from "./plugins/index.js"; // Default language

import en from "./l10n/en.js"; // Default settings

var defaults = {
  // Index of active slide on the start
  startIndex: 0,
  // Number of slides to preload before and after active slide
  preload: 1,
  // Should navigation be infinite
  infinite: true,
  // Class name to be applied to the content to reveal it
  showClass: "fancybox-zoomInUp",
  // "fancybox-fadeIn" | "fancybox-zoomInUp" | false
  // Class name to be applied to the content to hide it
  hideClass: "fancybox-fadeOut",
  // "fancybox-fadeOut" | "fancybox-zoomOutDown" | false
  // Should backdrop and UI elements fade in/out on start/close
  animated: true,
  // If browser scrollbar should be hidden
  hideScrollbar: true,
  // Element containing main structure
  parentEl: null,
  // Custom class name or multiple space-separated class names for the container
  mainClass: null,
  // Set focus on first focusable element after displaying content
  autoFocus: true,
  // Trap focus inside Fancybox
  trapFocus: true,
  // Set focus back to trigger element after closing Fancybox
  placeFocusBack: true,
  // Action to take when the user clicks on the backdrop
  click: "close",
  // "close" | "next" | null
  // Position of the close button - over the content or at top right corner of viewport
  closeButton: "inside",
  // "inside" | "outside"
  // Allow user to drag content up/down to close instance
  dragToClose: true,
  // Enable keyboard navigation
  keyboard: {
    Escape: "close",
    Delete: "close",
    Backspace: "close",
    PageUp: "next",
    PageDown: "prev",
    ArrowUp: "next",
    ArrowDown: "prev",
    ArrowRight: "next",
    ArrowLeft: "prev"
  },
  // HTML templates for various elements
  template: {
    // Close button icon
    closeButton: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" tabindex="-1"><path d="M20 20L4 4m16 0L4 20"/></svg>',
    // Loading indicator icon
    spinner: '<svg xmlns="http://www.w3.org/2000/svg" width="50" height="50" viewBox="25 25 50 50" tabindex="-1"><circle cx="50" cy="50" r="20"/></svg>',
    // Main container element
    main: null
  },

  /* Note: If the `template.main` option is not provided, the structure is generated as follows by default:
  <div class="fancybox__container" role="dialog" aria-modal="true" aria-hidden="true" aria-label="{{MODAL}}" tabindex="-1">
    <div class="fancybox__backdrop"></div>
    <div class="fancybox__carousel"></div>
  </div>
  */
  // Localization of strings
  l10n: en
}; // Object that contains all active instances of Fancybox

var instances = {}; // Number of Fancybox instances created, it is used to generate new instance "id"

var called = 0;

var Fancybox = /*#__PURE__*/function (_Base) {
  _inherits(Fancybox, _Base);

  var _super = _createSuper(Fancybox);

  /**
   * Fancybox constructor
   * @constructs Fancybox
   * @param {Object} [options] - Options for Fancybox
   */
  function Fancybox(items) {
    var _this;

    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    _classCallCheck(this, Fancybox);

    _this = _super.call(this, extend(true, {}, defaults, options));

    _this.bindHandlers();

    _this.state = "init";

    _this.setItems(items);

    _this.attachPlugins(Fancybox.Plugins); // "init" event marks the start of initialization and is available to plugins


    _this.trigger("init");

    if (_this.option("hideScrollbar") === true) {
      _this.hideScrollbar();
    }

    _this.initLayout();

    _this.initCarousel();

    _this.attachEvents();

    instances[_this.id] = _assertThisInitialized(_this); // "prepare" event will trigger the creation of additional layout elements, such as thumbnails and toolbar

    _this.trigger("prepare");

    _this.state = "ready"; // "ready" event will trigger the content to load

    _this.trigger("ready"); // Reveal container


    _this.$container.setAttribute("aria-hidden", "false"); // Focus on the first focus element in this instance


    if (_this.option("trapFocus")) {
      _this.focus();
    }

    return _this;
  }
  /**
   * Bind event handlers for referencability
   */


  _createClass(Fancybox, [{
    key: "bindHandlers",
    value: function bindHandlers() {
      for (var _i = 0, _arr = ["onMousedown", "onKeydown", "onClick", "onFocus", "onCreateSlide", "onTouchMove", "onTouchEnd", "onTransform"]; _i < _arr.length; _i++) {
        var methodName = _arr[_i];
        this[methodName] = this[methodName].bind(this);
      }
    }
    /**
     * Set up a functions that will be called whenever the specified event is delivered
     */

  }, {
    key: "attachEvents",
    value: function attachEvents() {
      document.addEventListener("mousedown", this.onMousedown);
      document.addEventListener("keydown", this.onKeydown, true); // Trap keyboard focus inside of the modal

      if (this.option("trapFocus")) {
        document.addEventListener("focus", this.onFocus, true);
      }

      this.$container.addEventListener("click", this.onClick);
    }
    /**
     * Removes previously registered event listeners
     */

  }, {
    key: "detachEvents",
    value: function detachEvents() {
      document.removeEventListener("mousedown", this.onMousedown);
      document.removeEventListener("keydown", this.onKeydown, true);
      document.removeEventListener("focus", this.onFocus, true);
      this.$container.removeEventListener("click", this.onClick);
    }
    /**
     * Initialize layout; create main container, backdrop nd layout for main carousel
     */

  }, {
    key: "initLayout",
    value: function initLayout() {
      var _this2 = this;

      this.$root = this.option("parentEl") || document.body; // Container

      var mainTemplate = this.option("template.main");

      if (mainTemplate) {
        this.$root.insertAdjacentHTML("beforeend", this.localize(mainTemplate));
        this.$container = this.$root.querySelector(".fancybox__container");
      }

      if (!this.$container) {
        this.$container = document.createElement("div");
        this.$root.appendChild(this.$container);
      } // Normally we would not need this, but Safari does not support `preventScroll:false` option for `focus` method
      // and that causes layout issues


      this.$container.onscroll = function () {
        _this2.$container.scrollLeft = 0;
        return false;
      };

      Object.entries({
        class: "fancybox__container",
        role: "dialog",
        "aria-modal": "true",
        "aria-hidden": "true",
        "aria-label": this.localize("{{MODAL}}")
      }).forEach(function (args) {
        var _this2$$container;

        return (_this2$$container = _this2.$container).setAttribute.apply(_this2$$container, _toConsumableArray(args));
      });

      if (this.option("animated")) {
        this.$container.classList.add("is-animated");
      } // Backdrop


      this.$backdrop = this.$container.querySelector(".fancybox__backdrop");

      if (!this.$backdrop) {
        this.$backdrop = document.createElement("div");
        this.$backdrop.classList.add("fancybox__backdrop");
        this.$container.appendChild(this.$backdrop);
      } // Carousel


      this.$carousel = this.$container.querySelector(".fancybox__carousel");

      if (!this.$carousel) {
        this.$carousel = document.createElement("div");
        this.$carousel.classList.add("fancybox__carousel");
        this.$container.appendChild(this.$carousel);
      } // Make instance reference accessible


      this.$container.Fancybox = this; // Make sure the container has an ID

      this.id = this.$container.getAttribute("id");

      if (!this.id) {
        this.id = this.options.id || ++called;
        this.$container.setAttribute("id", "fancybox-" + this.id);
      } // Add custom class name to main element


      var mainClass = this.options.mainClass;

      if (mainClass) {
        var _this$$container$clas;

        (_this$$container$clas = this.$container.classList).add.apply(_this$$container$clas, _toConsumableArray(mainClass.split(" ")));
      } // Add class name for <html> element


      document.documentElement.classList.add("with-fancybox");
      this.trigger("initLayout");
      return this;
    }
    /**
     * Prepares slides for the corousel
     * @returns {Array} Slides
     */

  }, {
    key: "setItems",
    value: function setItems(items) {
      var slides = [];

      var _iterator = _createForOfIteratorHelper(items),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var slide = _step.value;
          var $trigger = slide.$trigger;

          if ($trigger) {
            var dataset = $trigger.dataset || {};
            slide.src = dataset.src || $trigger.getAttribute("href") || slide.src;
            slide.type = dataset.type || slide.type; // Support items without `src`, e.g., when `data-fancybox` attribute added directly to `<img>` element

            if (!slide.src && $trigger instanceof HTMLImageElement) {
              slide.src = $trigger.currentSrc || slide.$trigger.src;
            }
          } // Check for thumbnail element


          var $thumb = slide.$thumb;

          if (!$thumb) {
            var origTarget = slide.$trigger && slide.$trigger.origTarget;

            if (origTarget) {
              if (origTarget instanceof HTMLImageElement) {
                $thumb = origTarget;
              } else {
                $thumb = origTarget.querySelector("img");
              }
            }

            if (!$thumb && slide.$trigger) {
              $thumb = slide.$trigger instanceof HTMLImageElement ? slide.$trigger : slide.$trigger.querySelector("img");
            }
          }

          slide.$thumb = $thumb || null; // Get thumbnail image source

          var thumb = slide.thumb;

          if (!thumb && $thumb) {
            thumb = $thumb.currentSrc || $thumb.src;

            if (!thumb && $thumb.dataset) {
              thumb = $thumb.dataset.lazySrc || $thumb.dataset.src;
            }
          } // Assume we have image, then use it as thumbnail


          if (!thumb && slide.type === "image") {
            thumb = slide.src;
          }

          slide.thumb = thumb || null; // Add empty caption to make things simpler

          slide.caption = slide.caption || "";
          slides.push(slide);
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }

      this.items = slides;
    }
    /**
     * Initialize main Carousel that will be used to display the content
     * @param {Array} slides
     */

  }, {
    key: "initCarousel",
    value: function initCarousel() {
      var _this3 = this;

      this.Carousel = new Carousel(this.$carousel, extend(true, {}, {
        prefix: "",
        classNames: {
          viewport: "fancybox__viewport",
          track: "fancybox__track",
          slide: "fancybox__slide"
        },
        textSelection: true,
        preload: this.option("preload"),
        friction: 0.88,
        slides: this.items,
        initialPage: this.options.startIndex,
        slidesPerPage: 1,
        infiniteX: this.option("infinite"),
        infiniteY: true,
        l10n: this.option("l10n"),
        Dots: false,
        Navigation: {
          classNames: {
            main: "fancybox__nav",
            button: "carousel__button",
            next: "is-next",
            prev: "is-prev"
          }
        },
        Panzoom: {
          textSelection: true,
          panOnlyZoomed: function panOnlyZoomed() {
            return _this3.Carousel && _this3.Carousel.pages && _this3.Carousel.pages.length < 2 && !_this3.options.dragToClose;
          },
          lockAxis: function lockAxis() {
            if (_this3.Carousel) {
              var rez = "x";

              if (_this3.options.dragToClose) {
                rez += "y";
              }

              return rez;
            }
          }
        },
        on: {
          "*": function _(name) {
            for (var _len = arguments.length, details = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
              details[_key - 1] = arguments[_key];
            }

            return _this3.trigger.apply(_this3, ["Carousel.".concat(name)].concat(details));
          },
          init: function init(carousel) {
            return _this3.Carousel = carousel;
          },
          createSlide: this.onCreateSlide
        }
      }, this.option("Carousel")));

      if (this.option("dragToClose")) {
        this.Carousel.Panzoom.on({
          // Stop further touch event handling if content is scaled
          touchMove: this.onTouchMove,
          // Update backdrop opacity depending on vertical distance
          afterTransform: this.onTransform,
          // Close instance if drag distance exceeds limit
          touchEnd: this.onTouchEnd
        });
      }

      this.trigger("initCarousel");
      return this;
    }
    /**
     * Process `createSlide` event to create caption element inside new slide
     */

  }, {
    key: "onCreateSlide",
    value: function onCreateSlide(carousel, slide) {
      var caption = slide.caption || "";

      if (typeof this.options.caption === "function") {
        caption = this.options.caption.call(this, this, this.Carousel, slide);
      }

      if (typeof caption === "string" && caption.length) {
        var $caption = document.createElement("div");
        var id = "fancybox__caption_".concat(this.id, "_").concat(slide.index);
        $caption.className = "fancybox__caption";
        $caption.innerHTML = caption;
        $caption.setAttribute("id", id);
        slide.$caption = slide.$el.appendChild($caption);
        slide.$el.classList.add("has-caption");
        slide.$el.setAttribute("aria-labelledby", id);
      }
    }
    /**
     * Handle focus event
     * @param {Event} event - Focus event
     */

  }, {
    key: "onFocus",
    value: function onFocus(event) {
      this.focus(event);
    }
    /**
     * Handle click event on the container
     * @param {Event} event - Click event
     */

  }, {
    key: "onClick",
    value: function onClick(event) {
      if (event.defaultPrevented) {
        return;
      } // Skip if clicked inside content area


      if (event.target.closest(".fancybox__content")) {
        return;
      } // Skip if text is selected


      if (getSelection().toString().length) {
        return;
      }

      if (this.trigger("click", event) === false) {
        return;
      }

      var action = this.option("click");

      switch (action) {
        case "close":
          this.close();
          break;

        case "next":
          this.next();
          break;
      }
    }
    /**
     * Handle panzoom `touchMove` event; Disable dragging if content of current slide is scaled
     */

  }, {
    key: "onTouchMove",
    value: function onTouchMove() {
      var panzoom = this.getSlide().Panzoom;
      return panzoom && panzoom.content.scale !== 1 ? false : true;
    }
    /**
     * Handle panzoom `touchEnd` event; close when quick flick up/down is detected
     * @param {Object} panzoom - Panzoom instance
     */

  }, {
    key: "onTouchEnd",
    value: function onTouchEnd(panzoom) {
      var distanceY = panzoom.dragOffset.y;

      if (Math.abs(distanceY) >= 150 || Math.abs(distanceY) >= 35 && panzoom.dragOffset.time < 350) {
        if (this.option("hideClass")) {
          this.getSlide().hideClass = "fancybox-throwOut".concat(panzoom.content.y < 0 ? "Up" : "Down");
        }

        this.close();
      } else if (panzoom.lockAxis === "y") {
        panzoom.panTo({
          y: 0
        });
      }
    }
    /**
     * Handle `afterTransform` event; change backdrop opacity based on current y position of panzoom
     * @param {Object} panzoom - Panzoom instance
     */

  }, {
    key: "onTransform",
    value: function onTransform(panzoom) {
      var $backdrop = this.$backdrop;

      if ($backdrop) {
        var yPos = Math.abs(panzoom.content.y);
        var opacity = yPos < 1 ? "" : Math.max(0.33, Math.min(1, 1 - yPos / panzoom.content.fitHeight * 1.5));
        this.$container.style.setProperty("--fancybox-ts", opacity ? "0s" : "");
        this.$container.style.setProperty("--fancybox-opacity", opacity);
      }
    }
    /**
     * Handle `mousedown` event to mark that the mouse is in use
     */

  }, {
    key: "onMousedown",
    value: function onMousedown() {
      document.body.classList.add("is-using-mouse");
    }
    /**
     * Handle `keydown` event; trap focus
     * @param {Event} event Keydown event
     */

  }, {
    key: "onKeydown",
    value: function onKeydown(event) {
      if (Fancybox.getInstance().id !== this.id) {
        return;
      }

      document.body.classList.remove("is-using-mouse");
      var key = event.key;
      var keyboard = this.option("keyboard");

      if (!keyboard || event.ctrlKey || event.altKey || event.shiftKey) {
        return;
      }

      var classList = document.activeElement && document.activeElement.classList;
      var isUIElement = classList && classList.contains("carousel__button"); // Allow to close using Escape button

      if (key !== "Escape" && !isUIElement) {
        var ignoreElements = event.target.isContentEditable || ["BUTTON", "TEXTAREA", "OPTION", "INPUT", "SELECT", "VIDEO"].indexOf(event.target.nodeName) !== -1;

        if (ignoreElements) {
          return;
        }
      }

      if (this.trigger("keydown", key, event) === false) {
        return;
      }

      var action = keyboard[key];

      if (typeof this[action] === "function") {
        this[action]();
      }
    }
    /**
     * Get the active slide. This will be the first slide from the current page of the main carousel.
     */

  }, {
    key: "getSlide",
    value: function getSlide() {
      var carousel = this.Carousel;
      if (!carousel) return null;
      var page = carousel.page === null ? carousel.option("initialPage") : carousel.page;
      var pages = carousel.pages || [];

      if (pages.length && pages[page]) {
        return pages[page].slides[0];
      }

      return null;
    }
    /**
     * Place focus on the first focusable element inside current slide
     * @param {Event} [event] - Focus event
     */

  }, {
    key: "focus",
    value: function focus(event) {
      var _this4 = this;

      var setFocusOn = function setFocusOn(node) {
        if (!node) {
          return;
        }

        _this4.ignoreFocusChange = true;

        try {
          if (node.setActive) {
            // IE/Edge
            node.setActive();
          } else if (Fancybox.preventScrollSupported) {
            // Modern browsers
            node.focus({
              preventScroll: true
            });
          } else {
            // Safari
            node.focus();
          }
        } catch (e) {}

        _this4.ignoreFocusChange = false;
      };

      var FOCUSABLE_ELEMENTS = ["a[href]", "area[href]", 'input:not([disabled]):not([type="hidden"]):not([aria-hidden])', "select:not([disabled]):not([aria-hidden])", "textarea:not([disabled]):not([aria-hidden])", "button:not([disabled]):not([aria-hidden])", "iframe", "object", "embed", "video", "audio", "[contenteditable]", '[tabindex]:not([tabindex^="-"]):not([disabled]):not([aria-hidden])'];

      if (this.ignoreFocusChange) {
        return;
      }

      if (["init", "closing", "customClosing", "destroy"].indexOf(this.state) > -1) {
        return;
      }

      var $currentSlide = this.getSlide().$el;

      if (!$currentSlide) {
        return;
      }

      if (event) {
        event.preventDefault();
      }

      var allFocusableElems = Array.from(this.$container.querySelectorAll(FOCUSABLE_ELEMENTS));
      var enabledElems = [];
      var $firstEl;
      var $firstBtn;

      for (var _i2 = 0, _allFocusableElems = allFocusableElems; _i2 < _allFocusableElems.length; _i2++) {
        var node = _allFocusableElems[_i2];
        var isInsideSlide = $currentSlide.contains(node); // Enable element if it's visible and is inside current slide or
        // not inside main carousel , e.g., not inside  previous/next slide, but located, for example, inside the toolbar

        if (node.offsetParent && (isInsideSlide || !this.Carousel.$viewport.contains(node))) {
          enabledElems.push(node);

          if (node.dataset.origTabindex !== undefined) {
            node.tabIndex = node.dataset.tabindex;
            node.removeAttribute("data-tabindex");
          }

          if (node.hasAttribute("autoFocus") || !$firstEl && isInsideSlide) {
            $firstEl = node;
          } else if (node.matches(".fancybox__button--close")) {
            $firstBtn = node;
          }
        } else {
          node.dataset.origTabindex = node.dataset.origTabindex === undefined ? node.getAttribute("tabindex") : node.dataset.origTabindex;
          node.tabIndex = -1;
        }
      }

      if (enabledElems.indexOf(document.activeElement) > -1) {
        this.lastFocus = document.activeElement;
        return;
      }

      if (!event) {
        setFocusOn($firstEl || $firstBtn || enabledElems[0]);
        return;
      }

      if (!$currentSlide.contains(document.activeElement)) {
        if (this.lastFocus === enabledElems[0]) {
          setFocusOn(enabledElems[enabledElems.length - 1]);
        } else {
          var idx = enabledElems.indexOf(this.lastFocus);

          if (idx < enabledElems.length - 2) {
            setFocusOn(enabledElems[idx + 1]);
          } else {
            setFocusOn(enabledElems[0]);
          }
        }

        this.lastFocus = document.activeElement;
      }
    }
    /**
     * Hide vertical page scrollbar and adjust right padding value of `body` element to prevent content from shifting
     * (otherwise the `body` element may become wider and the content may expand horizontally).
     */

  }, {
    key: "hideScrollbar",
    value: function hideScrollbar() {
      if (!canUseDOM) {
        return;
      }

      var scrollbarWidth = window.innerWidth - document.documentElement.getBoundingClientRect().width;
      var id = "fancybox-style-noscroll";
      var $style = document.getElementById(id);

      if ($style) {
        return;
      }

      if (scrollbarWidth > 0) {
        $style = document.createElement("style");
        $style.id = id;
        $style.type = "text/css";
        $style.innerHTML = ".compensate-for-scrollbar {padding-right: ".concat(scrollbarWidth, "px;}");
        document.getElementsByTagName("head")[0].appendChild($style);
        document.body.classList.add("compensate-for-scrollbar");
      }
    }
    /**
     * Stop hiding vertical page scrollbar
     */

  }, {
    key: "revealScrollbar",
    value: function revealScrollbar() {
      document.body.classList.remove("compensate-for-scrollbar");
      var el = document.getElementById("fancybox-style-noscroll");

      if (el) {
        el.remove();
      }
    }
    /**
     * Remove content for given slide
     * @param {Object} slide - Carousel slide
     */

  }, {
    key: "clearContent",
    value: function clearContent(slide) {
      // * Clear previously added content and class name
      this.Carousel.trigger("removeSlide", slide);

      if (slide.$content) {
        slide.$content.remove();
        slide.$content = null;
      }

      if (slide.$closeButton) {
        slide.$closeButton.remove();
        slide.$closeButton = null;
      }

      if (slide._className) {
        slide.$el.classList.remove(slide._className);
      }
    }
    /**
     * Set new content for given slide
     * @param {Object} slide - Carousel slide
     * @param {HTMLElement|String} html - HTML element or string containing HTML code
     * @param {Object} [opts] - Options
     */

  }, {
    key: "setContent",
    value: function setContent(slide, html) {
      var opts = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      var $content;
      var $el = slide.$el;

      if (html instanceof HTMLElement) {
        if (["img", "iframe", "video", "audio"].indexOf(html.nodeName.toLowerCase()) > -1) {
          $content = document.createElement("div");
          $content.appendChild(html);
        } else {
          $content = html;
        }
      } else {
        var $fragment = document.createRange().createContextualFragment(html);
        $content = document.createElement("div");
        $content.appendChild($fragment);
      }

      if (slide.filter && !slide.error) {
        $content = $content.querySelector(slide.filter);
      }

      if (!($content instanceof Element)) {
        this.setError(slide, "{{ELEMENT_NOT_FOUND}}");
        return;
      } // * Add class name indicating content type, for example `has-image`


      slide._className = "has-".concat(opts.suffix || slide.type || "unknown");
      $el.classList.add(slide._className); // * Set content

      $content.classList.add("fancybox__content"); // Make sure that content is not hidden and will be visible

      if ($content.style.display === "none" || getComputedStyle($content).getPropertyValue("display") === "none") {
        $content.style.display = slide.display || this.option("defaultDisplay") || "flex";
      }

      if (slide.id) {
        $content.setAttribute("id", slide.id);
      }

      slide.$content = $content;
      $el.prepend($content);
      this.manageCloseButton(slide);

      if (slide.state !== "loading") {
        this.revealContent(slide);
      }

      return $content;
    }
    /**
     * Create close button if needed
     * @param {Object} slide
     */

  }, {
    key: "manageCloseButton",
    value: function manageCloseButton(slide) {
      var _this5 = this;

      var position = slide.closeButton === undefined ? this.option("closeButton") : slide.closeButton;

      if (!position || position === "top" && this.$closeButton) {
        return;
      }

      var $btn = document.createElement("button");
      $btn.classList.add("carousel__button", "is-close");
      $btn.setAttribute("title", this.options.l10n.CLOSE);
      $btn.innerHTML = this.option("template.closeButton");
      $btn.addEventListener("click", function (e) {
        return _this5.close(e);
      });

      if (position === "inside") {
        // Remove existing one to avoid scope issues
        if (slide.$closeButton) {
          slide.$closeButton.remove();
        }

        slide.$closeButton = slide.$content.appendChild($btn);
      } else {
        this.$closeButton = this.$container.insertBefore($btn, this.$container.firstChild);
      }
    }
    /**
     * Make content visible for given slide and optionally start CSS animation
     * @param {Object} slide - Carousel slide
     */

  }, {
    key: "revealContent",
    value: function revealContent(slide) {
      var _this6 = this;

      this.trigger("reveal", slide);
      slide.$content.style.visibility = ""; // Add CSS class name that reveals content (default animation is "fadeIn")

      var showClass = false;

      if (!(slide.error || slide.state === "loading" || this.Carousel.prevPage !== null || slide.index !== this.options.startIndex)) {
        showClass = slide.showClass === undefined ? this.option("showClass") : slide.showClass;
      }

      if (!showClass) {
        this.done(slide);
        return;
      }

      slide.state = "animating";
      this.animateCSS(slide.$content, showClass, function () {
        _this6.done(slide);
      });
    }
    /**
     * Add class name to given HTML element and wait for `animationend` event to execute callback
     * @param {HTMLElement} $el
     * @param {String} className
     * @param {Function} callback - A callback to run
     */

  }, {
    key: "animateCSS",
    value: function animateCSS($element, className, callback) {
      if ($element) {
        $element.dispatchEvent(new CustomEvent("animationend", {
          bubbles: true,
          cancelable: true
        }));
      }

      if (!$element || !className) {
        if (typeof callback === "function") {
          callback();
        }

        return;
      }

      var handleAnimationEnd = function handleAnimationEnd(event) {
        if (event.currentTarget === this) {
          $element.removeEventListener("animationend", handleAnimationEnd);

          if (callback) {
            callback();
          }

          $element.classList.remove(className);
        }
      };

      $element.addEventListener("animationend", handleAnimationEnd);
      $element.classList.add(className);
    }
    /**
     * Mark given slide as `done`, e.g., content is loaded and displayed completely
     * @param {Object} slide - Carousel slide
     */

  }, {
    key: "done",
    value: function done(slide) {
      slide.state = "done";
      this.trigger("done", slide); // Trigger focus for current slide (and ignore preloaded slides)

      var currentSlide = this.getSlide();

      if (currentSlide && slide.index === currentSlide.index && this.option("autoFocus")) {
        this.focus();
      }
    }
    /**
     * Set error message as slide content
     * @param {Object} slide - Carousel slide
     * @param {String} message - Error message, can contain HTML code and template variables
     */

  }, {
    key: "setError",
    value: function setError(slide, message) {
      slide.error = message;
      this.hideLoading(slide);
      this.clearContent(slide); // Create new content

      var div = document.createElement("div");
      div.classList.add("fancybox-error");
      div.innerHTML = this.localize(message || "<p>{{ERROR}}</p>");
      this.setContent(slide, div, {
        suffix: "error"
      });
    }
    /**
     * Create loading indicator inside given slide
     * @param {Object} slide - Carousel slide
     */

  }, {
    key: "showLoading",
    value: function showLoading(slide) {
      var _this7 = this;

      slide.state = "loading";
      slide.$el.classList.add("is-loading");
      var $spinner = slide.$el.querySelector(".fancybox__spinner");

      if ($spinner) {
        return;
      }

      $spinner = document.createElement("div");
      $spinner.classList.add("fancybox__spinner");
      $spinner.innerHTML = this.option("template.spinner");
      $spinner.addEventListener("click", function () {
        if (!_this7.Carousel.Panzoom.velocity) _this7.close();
      });
      slide.$el.prepend($spinner);
    }
    /**
     * Remove loading indicator from given slide
     * @param {Object} slide - Carousel slide
     */

  }, {
    key: "hideLoading",
    value: function hideLoading(slide) {
      var $spinner = slide.$el && slide.$el.querySelector(".fancybox__spinner");

      if ($spinner) {
        $spinner.remove();
        slide.$el.classList.remove("is-loading");
      }

      if (slide.state === "loading") {
        this.trigger("load", slide);
        slide.state = "ready";
      }
    }
    /**
     * Slide carousel to next page
     */

  }, {
    key: "next",
    value: function next() {
      var carousel = this.Carousel;

      if (carousel && carousel.pages.length > 1) {
        carousel.slideNext();
      }
    }
    /**
     * Slide carousel to previous page
     */

  }, {
    key: "prev",
    value: function prev() {
      var carousel = this.Carousel;

      if (carousel && carousel.pages.length > 1) {
        carousel.slidePrev();
      }
    }
    /**
     * Slide carousel to selected page with optional parameters
     * Examples:
     *    Fancybox.getInstance().jumpTo(2);
     *    Fancybox.getInstance().jumpTo(3, {friction: 0})
     * @param  {...any} args - Arguments for Carousel `slideTo` method
     */

  }, {
    key: "jumpTo",
    value: function jumpTo() {
      var _this$Carousel;

      if (this.Carousel) (_this$Carousel = this.Carousel).slideTo.apply(_this$Carousel, arguments);
    }
    /**
     * Start closing the current instance
     * @param {Event} [event] - Optional click event
     */

  }, {
    key: "close",
    value: function close(event) {
      var _this8 = this;

      if (event) event.preventDefault(); // First, stop further execution if this instance is already closing
      // (this can happen if, for example, user clicks close button multiple times really fast)

      if (["closing", "customClosing", "destroy"].includes(this.state)) {
        return;
      } // Allow callbacks and/or plugins to prevent closing


      if (this.trigger("shouldClose", event) === false) {
        return;
      }

      this.state = "closing";
      this.Carousel.Panzoom.destroy();
      this.detachEvents();
      this.trigger("closing", event);

      if (this.state === "destroy") {
        return;
      } // Trigger default CSS closing animation for backdrop and interface elements


      this.$container.setAttribute("aria-hidden", "true");
      this.$container.classList.add("is-closing"); // Clear inactive slides

      var currentSlide = this.getSlide();
      this.Carousel.slides.forEach(function (slide) {
        if (slide.$content && slide.index !== currentSlide.index) {
          _this8.Carousel.trigger("removeSlide", slide);
        }
      }); // Start default closing animation

      if (this.state === "closing") {
        var hideClass = currentSlide.hideClass === undefined ? this.option("hideClass") : currentSlide.hideClass;
        this.animateCSS(currentSlide.$content, hideClass, function () {
          _this8.destroy();
        }, true);
      }
    }
    /**
     * Clean up after closing fancybox
     */

  }, {
    key: "destroy",
    value: function destroy() {
      if (this.state === "destroy") {
        return;
      }

      this.state = "destroy";
      this.trigger("destroy");
      var $trigger = this.option("placeFocusBack") ? this.getSlide().$trigger : null; // Destroy Carousel and then detach plugins;
      // * Note: this order allows plugins to receive `removeSlide` event

      this.Carousel.destroy();
      this.detachPlugins();
      this.Carousel = null;
      this.options = {};
      this.events = {};
      this.$container.remove();
      this.$container = this.$backdrop = this.$carousel = null;

      if ($trigger) {
        // `preventScroll` option is not yet supported by Safari
        // https://bugs.webkit.org/show_bug.cgi?id=178583
        if (Fancybox.preventScrollSupported) {
          $trigger.focus({
            preventScroll: true
          });
        } else {
          var scrollTop = document.body.scrollTop; // Save position

          $trigger.focus();
          document.body.scrollTop = scrollTop;
        }
      }

      delete instances[this.id];
      var nextInstance = Fancybox.getInstance();

      if (nextInstance) {
        nextInstance.focus();
        return;
      }

      document.documentElement.classList.remove("with-fancybox");
      document.body.classList.remove("is-using-mouse");
      this.revealScrollbar();
    }
    /**
     * Create new Fancybox instance with provided options
     * Example:
     *   Fancybox.show([{ src : 'https://lipsum.app/id/1/300x225' }]);
     * @param {Array} items - Gallery items
     * @param {Object} [options] - Optional custom options
     * @returns {Object} Fancybox instance
     */

  }], [{
    key: "show",
    value: function show(items) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      return new Fancybox(items, options);
    }
    /**
     * Starts Fancybox if event target matches any opener or target is `trigger element`
     * @param {Event} event - Click event
     * @param {Object} [options] - Optional custom options
     */

  }, {
    key: "fromEvent",
    value: function fromEvent(event) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      //  Allow other scripts to prevent starting fancybox on click
      if (event.defaultPrevented) {
        return;
      } // Don't run if right-click


      if (event.button && event.button !== 0) {
        return;
      } // Ignore command/control + click


      if (event.ctrlKey || event.metaKey || event.shiftKey) {
        return;
      } // Support `trigger` element, e.g., start fancybox from different DOM element, for example,
      // to have one preview image for hidden image gallery


      var eventTarget = event.target;
      var triggerGroupName;

      if (eventTarget.matches("[data-fancybox-trigger]") || (eventTarget = eventTarget.closest("[data-fancybox-trigger]"))) {
        triggerGroupName = eventTarget && eventTarget.dataset && eventTarget.dataset.fancyboxTrigger;
      }

      if (triggerGroupName) {
        var triggerItems = document.querySelectorAll("[data-fancybox=\"".concat(triggerGroupName, "\"]"));
        var triggerIndex = parseInt(eventTarget.dataset.fancyboxIndex, 10) || 0;
        eventTarget = triggerItems.length ? triggerItems[triggerIndex] : eventTarget;
      }

      if (!eventTarget) {
        eventTarget = event.target;
      } // * Try to find matching openener


      var matchingOpener;
      var target;
      Array.from(Fancybox.openers.keys()).reverse().some(function (opener) {
        target = eventTarget;
        var found = false;

        try {
          if (target instanceof Element && (typeof opener === "string" || opener instanceof String)) {
            // Chain closest() to event.target to find and return the parent element,
            // regardless if clicking on the child elements (icon, label, etc)
            found = target.matches(opener) || (target = target.closest(opener));
          }
        } catch (error) {}

        if (found) {
          event.preventDefault();
          matchingOpener = opener;
          return true;
        }

        return false;
      });
      var rez = false;

      if (matchingOpener) {
        options.event = event;
        options.target = target;
        target.origTarget = event.target;
        rez = Fancybox.fromOpener(matchingOpener, options); // Check if the mouse is being used
        // Waiting for better browser support for `:focus-visible` -
        // https://drafts.csswg.org/selectors-4/#the-focus-visible-pseudo

        var nextInstance = Fancybox.getInstance();

        if (nextInstance && nextInstance.state === "ready" && event.detail) {
          document.body.classList.add("is-using-mouse");
        }
      }

      return rez;
    }
    /**
     * Starts Fancybox using selector
     * @param {String} opener - Valid CSS selector string
     * @param {Object} [options] - Optional custom options
     */

  }, {
    key: "fromOpener",
    value: function fromOpener(opener) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      // Callback function called once for each group element that
      // 1) converts data attributes to boolean or JSON
      // 2) removes values that could cause issues
      var mapCallback = function mapCallback(el) {
        var falseValues = ["false", "0", "no", "null", "undefined"];
        var trueValues = ["true", "1", "yes"];
        var dataset = Object.assign({}, el.dataset);
        var options = {};

        for (var _i3 = 0, _Object$entries = Object.entries(dataset); _i3 < _Object$entries.length; _i3++) {
          var _ref3 = _Object$entries[_i3];

          var _ref2 = _slicedToArray(_ref3, 2);

          var key = _ref2[0];
          var value = _ref2[1];

          if (key === "fancybox") {
            continue;
          }

          if (key === "width" || key === "height") {
            options["_".concat(key)] = value;
          } else if (typeof value === "string" || value instanceof String) {
            if (falseValues.indexOf(value) > -1) {
              options[key] = false;
            } else if (trueValues.indexOf(options[key]) > -1) {
              options[key] = true;
            } else {
              try {
                options[key] = JSON.parse(value);
              } catch (e) {
                options[key] = value;
              }
            }
          } else {
            options[key] = value;
          }
        }

        if (el instanceof Element) {
          options.$trigger = el;
        }

        return options;
      };

      var items = [],
          index = options.startIndex || 0,
          target = options.target || null; // Get options

      options = extend({}, options, Fancybox.openers.get(opener)); // Get matching nodes

      var groupAttr = options.groupAttr === undefined ? "data-fancybox" : options.groupAttr;
      var groupValue = groupAttr && target && target.getAttribute("".concat(groupAttr));
      var groupAll = options.groupAll === undefined ? false : options.groupAll;

      if (groupAll || groupValue) {
        items = [].slice.call(document.querySelectorAll(opener));

        if (!groupAll) {
          items = items.filter(function (el) {
            return el.getAttribute("".concat(groupAttr)) === groupValue;
          });
        }
      } else {
        items = [target];
      }

      if (!items.length) {
        return false;
      } // Exit if current instance is triggered from the same element


      var currentInstance = Fancybox.getInstance();

      if (currentInstance && items.indexOf(currentInstance.options.$trigger) > -1) {
        return false;
      } // Index of current item in the gallery


      index = target ? items.indexOf(target) : index; // Convert items in a format supported by fancybox

      items = items.map(mapCallback); // * Create new fancybox instance

      return new Fancybox(items, extend({}, options, {
        startIndex: index,
        $trigger: target
      }));
    }
    /**
     * Attach a click handler function that starts Fancybox to the selected items, as well as to all future matching elements.
     * @param {String} selector - Selector that should match trigger elements
     * @param {Object} [options] - Custom options
     */

  }, {
    key: "bind",
    value: function bind(selector) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      function attachClickEvent() {
        document.body.addEventListener("click", Fancybox.fromEvent, false);
      }

      if (!canUseDOM) {
        return;
      }

      if (!Fancybox.openers.size) {
        if (/complete|interactive|loaded/.test(document.readyState)) {
          attachClickEvent();
        } else {
          document.addEventListener("DOMContentLoaded", attachClickEvent);
        }
      }

      Fancybox.openers.set(selector, options);
    }
    /**
     * Remove the click handler that was attached with `bind()`
     * @param {String} selector - A selector which should match the one originally passed to .bind()
     */

  }, {
    key: "unbind",
    value: function unbind(selector) {
      Fancybox.openers.delete(selector);

      if (!Fancybox.openers.size) {
        Fancybox.destroy();
      }
    }
    /**
     * Immediately destroy all instances (without closing animation) and clean up all bindings..
     */

  }, {
    key: "destroy",
    value: function destroy() {
      var fb;

      while (fb = Fancybox.getInstance()) {
        fb.destroy();
      }

      Fancybox.openers = new Map();
      document.body.removeEventListener("click", Fancybox.fromEvent, false);
    }
    /**
     * Retrieve instance by identifier or the top most instance, if identifier is not provided
     * @param {String|Numeric} [id] - Optional instance identifier
     */

  }, {
    key: "getInstance",
    value: function getInstance(id) {
      if (id) {
        return instances[id];
      }

      var instance = Object.values(instances).reverse().find(function (instance) {
        if (!["closing", "customClosing", "destroy"].includes(instance.state)) {
          return instance;
        }

        return false;
      });
      return instance || null;
    }
    /**
     * Close all or topmost currently active instance.
     * @param {boolean} [all] - All or only topmost active instance
     */

  }, {
    key: "close",
    value: function close() {
      var all = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
      var instance = null;

      while (instance = Fancybox.getInstance()) {
        instance.close();
        if (!all) return;
      }
    }
  }]);

  return Fancybox;
}(Base); // Expose version


Fancybox.version = "__VERSION__"; // Expose defaults

Fancybox.defaults = defaults; // Expose openers

Fancybox.openers = new Map(); // Add default plugins

Fancybox.Plugins = Plugins; // Auto init with default options

Fancybox.bind("[data-fancybox]"); // Prepare plugins

for (var _i4 = 0, _Object$entries2 = Object.entries(Fancybox.Plugins || {}); _i4 < _Object$entries2.length; _i4++) {
  var _ref6 = _Object$entries2[_i4];

  var _ref5 = _slicedToArray(_ref6, 2);

  var key = _ref5[0];
  var Plugin = _ref5[1];

  if (typeof Plugin.create === "function") {
    Plugin.create(Fancybox);
  }
}

export { Fancybox };